import React from 'react';

const PricingSectionHeader = () => {
  return (
    <div className="text-center mb-12">
      <h2 className="text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
        Simple, transparent pricing
      </h2>
      <p className="mt-4 text-xl text-muted-foreground">
        Choose the plan that's right for you
      </p>
    </div>
  );
};

export default PricingSectionHeader;